import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResultsetItem } from '@models/resultset-item';
import { ResultTabsService } from '@services/results/result-tabs.service';
import { ResultsStoreService } from '@services/results/results-store.service';
import { ResultsService } from '@services/results/results.service';
import { SettingsService } from '@services/settings/settings.service';
import { Subscription } from 'rxjs';
import { toggleEllipsisExpandableTextOnClick } from '@helpers/toggle-ellipsis-expandable-text-on-click';

@Component({
  selector: 'app-manage-results',
  templateUrl: './manage-results.component.html',
  styleUrls: ['./manage-results.component.scss'],
})
export class ManageResultsComponent implements OnInit, OnDestroy {
  public toggleEllipsisExpandableTextOnClick = toggleEllipsisExpandableTextOnClick;
  public resultsets: ResultsetItem[];
  // private resultsetErrorNotifications: Map<number, Notification>;
  // private outofdateErrorNotifications: Map<number, Notification>;
  private subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<ManageResultsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private resultsStore: ResultsStoreService,
    // private notifications: NotificationsService,
    private resultsService: ResultsService,
    private tabsService: ResultTabsService,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    const resultsSubscription = this.resultsStore.resultsList$.subscribe(_ => {
      this.resultsets = this.resultsStore.getResultTree();
      // this.resultsetErrorNotifications = this.notifications.getNotificationListByType('resultError');
      // this.outofdateErrorNotifications = this.notifications.getNotificationListByType('resultset-ood');
    });

    this.subscriptions.push(resultsSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  public getScenarioColor(resultset: ResultsetItem): string {
    return this.settingsService.getScenarioColor(resultset);
  }

  public setClose(element: ResultsetItem) {
    element.OpenCloseHappening = true;
    setTimeout(() => {
      this.resultsStore.hideShowResultSet(element, true);
    });
  }

  public setOpen(element: ResultsetItem) {
    element.OpenCloseHappening = true;
    setTimeout(() => {
      this.resultsStore.hideShowResultSet(element, false);
      if (element.Is_Stress) {
        const baselineToOpen = this.resultsets.find(x => element.RunID_Used === x.RunID);
        if (baselineToOpen && !baselineToOpen.Hidden) {
          // this.tabsService.changeView('summary');
          // this.tabsService.selectActiveTab(baselineToOpen.Mnemonic);
          this.tabsService.selectTab({ tabName: baselineToOpen.Mnemonic, type: 'summary' });
        }
      } else {
        // this.tabsService.changeView('summary');
        // this.tabsService.selectActiveTab(element.Mnemonic);
        this.tabsService.selectTab({ tabName: element.Mnemonic, type: 'summary' });
      }
    });
  }

  public getParentStatus(resultset: ResultsetItem) {
    if (resultset.Is_Stress) {
      const parentBaseline = this.resultsets.find(r => r.RunID === resultset.RunID_Used);
      return parentBaseline.Hidden || false;
    } else {
      return false;
    }
  }

  public toggleRow(target) {
    target.Expanded = !target.Expanded;
  }

  public async deleteElement(element: ResultsetItem) {
    element.BeingDeleted = true;
    const response = await this.resultsService.deleteSavedResultSet(element);

    if (response) {
      element.BeingDeleted = false;
      this.resultsStore.remove(element);
    } else if (response === false) {
      element.BeingDeleted = false;
    }
  }

  public resetFocus(): void {
    (document.activeElement as HTMLElement).blur();
  }

  // public getNotificationForElement(element: ResultsetItem) {
  //   const mnemonic = element.Mnemonic;
  //   const mergedArrays = [
  //     ...Array.from(this.resultsetErrorNotifications.values()),
  //     ...Array.from(this.outofdateErrorNotifications.values())
  //   ];
  //   const errorFound = mergedArrays.find((error: Notification) => error.references.mnemonic === mnemonic);
  //   return errorFound;
  // }
}
